import { Component, Input } from "@angular/core";
import { CustomModal } from "../../../core/components/base-modals";
import { config } from "@config";
import { Router } from "@angular/router";
import { BpModalCanDismiss } from "@models/interfaces/bp-modal-can-dismiss";
import { MODAL_ANIMATION_TIMEOUT } from "@helpers/constants";
import { OnfidoService } from "../../services/onfido.service";
import { VerificationModalFacade } from "@modules/verification/modal/state/verification-modal.facade";

@Component({
	templateUrl: "./verification-onfido-failed.component.html",
	styleUrls: ["./verification-onfido-failed.component.scss"],
	standalone: false
})
export class VerificationOnfidoFailedComponent extends CustomModal implements BpModalCanDismiss {
	@Input() public reason: string = "other_error"; // A generic default
	private canDismiss: boolean = false;

	public constructor(
		private verificationModalFacade: VerificationModalFacade,
		private onfidoService: OnfidoService,
		private router: Router
	) {
		super();
		this.onfidoService.setVerificationFail(true);
	}

	public getHeaderTitle(): string {
		return "verification_onfido_failed_header_" + this.reason;
	}

	public getDescription(): string {
		return "verification_onfido_failed_description_" + this.reason;
	}

	public showDocumentListUrl(): boolean {
		return this.reason === "doc_notaccepted";
	}

	public getSupportedDocumentsLink(): string {
		return this.translationService.getHdLink() + config.externalPaths["verification"]["onfido"]["failedLink"];
	}

	public getButtonText(): string {
		if (this.requiresVerify()) {
			return "verification_onfido_failed_button_verify";
		}
		if (this.requiresSupport()) {
			return "verification_onfido_failed_button_contact";
		}
		return "ok";
	}

	private requiresVerify(): boolean {
		return ["doc_expired", "doc_notaccepted", "doc_notreadable", "video_error", "doc_scan"].includes(this.reason);
	}

	private requiresSupport(): boolean {
		return ["other_error"].includes(this.reason);
	}

	public onButtonClick(): void {
		if (this.requiresVerify()) {
			if (!this.verificationModalFacade.openVerification()) {
				this.close();
				setTimeout(() => {
					this.router.navigateByUrl("/verification");
				}, MODAL_ANIMATION_TIMEOUT);
			}
			this.onCloseClick();
			return;
		}
		if (this.requiresSupport()) {
			window.open(this.translationService.getHdLink(""), "_blank");
			return;
		}
		this.onCloseClick();
	}

	public onCloseClick(): void {
		this.canDismiss = true;
		this.close();
	}

	public modalCanDismiss(): boolean {
		return this.canDismiss;
	}
}
